var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"checkinCancel"}},[_c('div',{staticClass:"check-tab"},[_c('CheckInTab',{attrs:{"tabInit":_vm.tabInit}})],1),_c('div',{staticClass:"checkin-wrap"},[_c('div',{staticClass:"step-wrap"},[_c(_vm.stepName,{tag:"components",attrs:{"stepData":_vm.stepData},on:{"callback":_vm.nextStep}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }